import { PayloadAction, createAction, createSlice } from "@reduxjs/toolkit";
import { AppThunk } from "../store";

type IAlert = {
  classify: string;
  message: string;
  isShowAlert: boolean;
  isShowSnackbar: boolean;
  isShowCustomSnackbar: boolean;
};

type AlertClassify = "success" | "info" | "error" | "";

const initialState = {
  classify: "",
  message: "",
  isShowAlert: false,
  isShowSnackbar: false,
  isShowCustomSnackbar: false,
} as IAlert;

export const resetAlertState = createAction("alert/resetState");

export const alertSlice = createSlice({
  name: "alert",
  initialState: initialState,
  reducers: {
    showAlert: (
      state,
      action: PayloadAction<{ classify: AlertClassify; message: string }>,
    ) => {
      state.isShowAlert = true;
      state.message = action.payload.message;
      state.classify = action.payload.classify;
    },
    showSnackbar: (state, action: PayloadAction<{ message: string }>) => {
      state.isShowSnackbar = true;
      state.message = action.payload.message;
    },
    showCustomSnackbar: (state, action: PayloadAction<{ message: string }>) => {
      state.isShowCustomSnackbar = true;
      state.message = action.payload.message;
    },
    hideAlert: (state) => {
      state.classify = "";
      state.message = "";
      state.isShowAlert = false;
    },
    hideSnackbar: (state) => {
      state.message = "";
      state.isShowSnackbar = false;
      state.isShowCustomSnackbar = false;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(resetAlertState, () => initialState);
  },
});

// Action creators are generated for each case reducer function
export const {
  showAlert,
  hideAlert,
  showSnackbar,
  hideSnackbar,
  showCustomSnackbar,
} = alertSlice.actions;

const setValueToAlert =
  (message: string, classify: AlertClassify): AppThunk =>
  async (dispatch) => {
    return new Promise((resolve) => {
      dispatch(showAlert({ message, classify }));
      setTimeout(() => {
        dispatch(hideAlert());
        resolve();
      }, 3000);
    });
  };

export const setNotificationSuccess = (message: string) =>
  setValueToAlert(message, "success");

export const setNotificationInfo = (message: string) =>
  setValueToAlert(message, "info");

export const setNotificationError = (message: string) =>
  setValueToAlert(message, "error");

export const setNotificationDefault = (message: string) =>
  setValueToAlert(message, "");

export default alertSlice.reducer;
